import useStaticProductCardData from 'hooks/useStaticProductCardData';

const useStaticWishlistData = ({ productIds = [] }) => {
  const { loading, products } = useStaticProductCardData({ 
    productIds,
    limit: -1, // this is to avoid double loading in useProductListingQuery
  });

  return {
    loading,
    products
  }
};

export default useStaticWishlistData;